import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProduitService } from '../../services/produit.service';

@Injectable()
export class ColonnesResolver implements Resolve<Observable<string>> {

  constructor(
    private produitService: ProduitService
  ) { } 

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    return this.produitService.getColonnes().pipe(map(
      (res) => {
        return JSON.stringify(res);
      }),
      catchError(err => {
        return empty();
      }
    ));
  }

}
